import {Component} from '@angular/core';

@Component({
    selector: 'ngx-material-timepicker-button',
    templateUrl: './ngx-material-timepicker-button.component.html',
    styleUrls: ['./ngx-material-timepicker-button.component.scss']
})
export class NgxMaterialTimepickerButtonComponent {
}
